import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import campaignsRoutes from './domains/campaigns/_campaigns-routes';
import ordersRoutes from './domains/orders/_orders-routes';
import promotionsRoutes from './domains/promotions/_promotions-routes';
import storesRoutes from './domains/stores/_stores-routes';
import settingsRoutes from './domains/settings/_settings-routes';
import whitelabelRoutes from './domains/whitelabel/_whitelabel-routes';

let router = new VueRouter({
  mode: 'history',
  routes: [{
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      redirect: '/campaigns/all',
      name: 'home',
    },
    campaignsRoutes,
    ordersRoutes,
    promotionsRoutes,
    storesRoutes,
    settingsRoutes,
    whitelabelRoutes,
  ],
});

export default router;